<template>
    <v-container fluid fill-height>
        <Headful title="Dienstverlener profiel insturen"></Headful>
        <Header
            color="white"
            show-logo
            :dark="false"
            show-back-button
            extended
        ></Header>
        <v-layout align-center class="mt-5 mb-5">
            <v-flex>
                <v-form ref="form" @submit.prevent="submit" class="px-5" :disabled="loading || submitting || success">
                    <v-card class="elevation-0">
                        <v-card-text class="pa-7">
                            <h1 class="text-h5 mb-5 text-center text--success">Dienstverlener profiel insturen </h1>
                            <p class="text-center mb-5">Vul de onderstaande gegevens in om je dienstverlener profiel in te sturen.</p>
                            <div v-if="!success">
                                <v-text-field outlined rounded required hide-details="auto" class="mb-4"
                                    label="Naam" v-model="organisation.name" :rules="[requiredRule]"
                                ></v-text-field>
                                <v-text-field outlined rounded required hide-details="auto" class="mb-4"
                                    label="Hoofdactiviteit bedrijf" v-model="organisation.mainActivity" :rules="[requiredRule]"
                                ></v-text-field>
                                <v-text-field outlined rounded required hide-details="auto" class="mb-4"
                                    label="Telefoonnummer" v-model="organisation.phoneNumber" type="tel" :rules="[requiredRule, phoneNumberRule]"
                                ></v-text-field>
                                <v-text-field outlined rounded required hide-details="auto" class="mb-4"
                                    label="E-mailadres" v-model="organisation.email" type="email" :rules="[requiredRule, emailRule]"
                                ></v-text-field>
                                <v-text-field outlined rounded required hide-details="auto" class="mb-4"
                                              label="Website" v-model="organisation.website" type="email" :rules="[requiredRule]"
                                ></v-text-field>
                                <v-textarea outlined rounded required no-resize hide-details="auto" :maxlength="200" counter="200" class="mb-4"
                                    label="Introductie/presentatietekst (max. 200 woorden)" v-model="organisation.introductionText" :rules="[requiredRule]"
                                ></v-textarea>
                                <v-text-field outlined rounded class="mb-2" persistent-hint hide-details="auto" :rules="[videoRule]"
                                    label="Video" v-model="organisation.video" hint="Voer een geldige YouTube of Vimeo URL in."
                                ></v-text-field>
                                <v-file-input outlined rounded prepend-icon="fa-camera" hide-details="auto" class="mb-4"
                                    label="Profielfoto" v-model="organisation.logo" accept="image/*"
                                ></v-file-input>
                                <v-select outlined rounded hide-details="auto" class="mb-4" multiple
                                    v-for="facet in facets" :key="facet.id" :required="facet.isRequired" :rules="facet.isRequired ? [notEmptyRule] : []"
                                    :items="facet.choices"
                                    v-model="organisation.facetChoices['facet'+facet.id]"
                                    item-value="id"
                                    item-text="value"
                                    :label="facet.name"
                                >
                                    <template v-slot:prepend v-if="facet.id == 8">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                    <v-icon
                                                        class="pl-2 mr-2"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                    >
                                                        fa fa-info
                                                    </v-icon>
                                            </template>
                                            <strong>Incidentele kortdurende inzet (korte termijn) zoals vervangingen</strong><br>
                                            - Voor een dag (b.v. met een themales).<br><br>

                                            <strong>Structurele planbare inzet (b.v. over een schooljaar)</strong><br>
                                            - Voor een aansluitende reeks van dagen (bijvoorbeeld een week of maand waarin op elke dag of dagdeel een andere groep binnen de school/het bestuur wordt lesgegeven).<br>
                                            - Voor een niet aansluitende reeks van dagen om een lessenreeks aan 1 groep te verzorgen (b.v. 1 dag per maand gedurende 8 maanden).<br><br>

                                            <strong>Evenementorganisatie/coördinatie van themadagen</strong><br>
                                            Voor b.v. een of twee dagen om een evenement te coördineren of begeleiden, bijvoorbeeld een sportdag of een benefietactie, o.i.d.
                                        </v-tooltip>
                                    </template>
                                </v-select>
                                <v-radio-group v-model="acceptTerms" :rules="[acceptTermsRule]" class="mb-4">
                                    <template v-slot:label>
                                        <div>Passie voor Onderwijs is ingericht om scholen en professionals met elkaar in contact te brengen. Om jouw profiel zichtbaar te maken voor schoolbesturen, hebben we je jouw toestemming nodig.<br />
                                            <strong>Ik geef toestemming voor het delen van mijn gegevens met schoolbesturen die gebruikmaken van Passie voor Onderwijs.</strong></div>
                                    </template>
                                    <v-radio :value="true">
                                        <template v-slot:label>
                                            <div>Ja</div>
                                        </template>
                                    </v-radio>
                                    <v-radio :value="false">
                                        <template v-slot:label>
                                            <div>Nee</div>
                                        </template>
                                    </v-radio>
                                </v-radio-group>
                                <RegisterOrganisationDialog class="mb-2 elevation-0" :submitting="submitting" :loading="loading" @submit="submit"></RegisterOrganisationDialog>
                            </div>
                            <v-alert v-else color="success">De dienstverlener is succesvol opgestuurd, er wordt zo spoedig mogelijk contact met je opgenomen.</v-alert>
                            <v-btn :to="{name: 'SignIn'}" block outlined rounded color="secondary" class="elevation-0">Terug naar inloggen</v-btn>
                        </v-card-text>
                    </v-card>
                </v-form>
            </v-flex>

        </v-layout>
    </v-container>
</template>

<script>
import Headful from "@/components/layout/Headful";
import Header from "@/components/layout/Header";
import apiClient from "@/api/apiClient";
import {mapState} from "vuex";
import RegisterOrganisationDialog from "@/components/organisation/RegisterOrganisationDialog.vue";

const youtubeRegex = /(https?:\/\/)?(www.)?(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})[?]?.*/;
const vimeoRegex = /(https?:\/\/)?(www.)?(player.)?vimeo.com\/([a-z]*\/)*([0-9]{6,11})[?]?.*/;
const phoneNumberRegex = /^\(?([+]31|0031|0)(\s?|-)([0-9]\s{0,3}){9}$/g;
const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export default {
    name: "RegisterOrganisation",
    components: {
        Headful,
        Header,
        RegisterOrganisationDialog,
    },
    data: () => ({
        submitting: false,
        submitted: false,
        loading: true,
        success: false,
        acceptTerms: null,
        organisation: {
            name: null,
            mainActivity: null,
            phoneNumber: null,
            email: null,
            website: null,
            introductionText: null,
            video: null,
            logo: null,
            facetChoices: {},
        },
        requiredRule: (value) => !!value || "Dit veld is verplicht.",
        videoRule: (value) => (!value || (!!value && (value.match(youtubeRegex) || value.match(vimeoRegex)))) || "Ongeldige YouTube of Vimeo URL.",
        phoneNumberRule: (value) => (!value || (!!value && value.match(phoneNumberRegex))) || "Ongeldig telefoonnummer, gebruik 10 cijfers zonder spaties.",
        emailRule: (value) => (!value || (!!value && value.match(emailRegex))) || "Ongeldig e-mailadres.",
        acceptTermsRule: (value) => !!value || "Het profiel kan niet ingestuurd worden zonder toestemming.",
    }),
    computed: {
        notEmptyRule () {
            return (value) => (!this.submitted || value.length > 0) || "Dit veld is verplicht.";
        },
        ...mapState({
            facets: state => state.organisation.facets,
        }),
    },
    created() {
        this.$store.dispatch('organisation/updateFacets')
            .then(() => {
                this.facets.forEach(facet => {
                    this.organisation.facetChoices['facet'+facet.id] = [];
                });
                this.loading = false;
            })
            .catch(() => {
                return this.$store.dispatch('showSnackbar', { color: 'error', text: 'Er kon niet met de server worden verbonden, controleer je verbinding' });
            })
    },
    methods: {
        submit () {
            this.submitted = true;

            // Check if form is valid
            if (!this.$refs.form.validate() || this.submitting || this.loading) {
                return;
            }

            this.submitting = true;

            const formData = new FormData();
            Object.keys(this.organisation).forEach(key => {
                if (this.organisation[key]) {
                    formData.append(key, key === 'facetChoices' ? JSON.stringify(this.organisation[key]) : this.organisation[key]);
                }
            });

            // Submit organisation
            apiClient.post('/organisaties/nieuw', formData).then(() => {
                // Success
                this.success = true;
                this.$router.push({name: 'RegisterSuccessOrganisation'})
            }).catch((e) => {
                console.error(e);
                return this.$store.dispatch('showSnackbar', { color: 'error', text: 'Ongeldige gegevens, controleer de invoer' });
            }).finally(() => {
                this.submitting = false;
            });
        },
    },
}
</script>

<style scoped>

</style>
